<template>

  <div>
    <div>
      <router-view/>
    </div>
    <BookingFunnelTracker />
    <BookingLiveChatWidget v-if="!$route.meta.hideLiveChat" />
  </div>
  
  </template>

<script>
import BookingLiveChatWidget from '@/global-components/BookingLiveChatWidget.vue';
import BookingFunnelTracker from '@/global-components/BookingFunnelTracker.vue';

export default {
  name: 'App',
  components: {
    BookingFunnelTracker,
    BookingLiveChatWidget,
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
